import React from 'react'
import {Media, Button, TabContent, TabPane, Nav, NavItem, NavLink, Form, FormGroup, Input, Label, InputGroup, InputGroupAddon, ListGroup, ListGroupItem, ListGroupItemHeading, Badge} from 'reactstrap'
import Loader from 'react-loader-spinner'
import TimeField from 'react-simple-timefield'
import {Controller, Command, FLOW_UNITS, AppError} from '../../models'
import { WS_URL, sendCommand, updateController, getCommandHistoryForController} from "../../api"
import Websocket from "react-websocket"

import PauseIcon from 'react-icons/lib/fa/pause'
import PlayIcon from 'react-icons/lib/fa/play'
import RepeatIcon from 'react-icons/lib/fa/repeat'
import SquareIcon from 'react-icons/lib/fa/square'
import FieldIcon from 'react-icons/lib/fa/map-pin'
import ClockIcon from 'react-icons/lib/fa/clock-o'
import BatchIcon from 'react-icons/lib/fa/th-large'
import DatabaseIcon from 'react-icons/lib/fa/database'
import ResetIcon from 'react-icons/lib/fa/asterisk'
import WarningIcon from 'react-icons/lib/fa/exclamation-triangle'
import HistoryIcon from 'react-icons/lib/fa/history'

import SendIcon from 'react-icons/lib/fa/upload'
import '../../stylesheets/CommandPanel.css'
import CommandStatusModal from "./CommandStatusModal"
import {COMMAND_STATUSES} from "./CommandStatusModal"
import ModelListTable from "./ModelListTable"

import CircleIcon from 'react-icons/lib/fa/circle'
import LoadingIcon from 'react-icons/lib/fa/hourglass-1'
import BrokenCircleIcon from 'react-icons/lib/fa/times-circle'
import SFLogo from '../../images/sf-logo-simple.png'

const STATUS_FIELD_NAME = "_"

let statusIconForCommand = (command) => {
    if (command.status === 0) {
        return <LoadingIcon className="text-info mr-1 ml-0 mr-sm-3"/>
    } else if (command.status === 1) {
        return <CircleIcon className="text-success mr-1 ml-0 mr-sm-3"/>
    } else {
        return <BrokenCircleIcon className="text-danger mr-1 ml-0 mr-sm-3"/>
    }
}

let statusTextForCommand = (command) => {
    if (command.status === 0) {
        return "Sending..."
    } else if (command.status === 1) {
        return "Sent"
    } else {
        return "Failed"
    }
}

let statusGenerator = (command) => {
    return <span title={statusTextForCommand(command)}>
        {statusIconForCommand(command)}
    </span>
}

let dateGenerator = (command) => {
    return <span title={command.datetime}>
        {command.date}
    </span>
}

let userGenerator = (command) => {
    return <span title={command.user}>
        {command.sentBy && command.sentBy.isSupport ?
            <Media object src={SFLogo} className="inline-media-icon mr-2 position-relative" alt="Support User" style={{top:-2}}/> :
                null}
        {command.user}
    </span>
}

class ControllerSettingsPanel extends React.Component {
    constructor(props) {
        super(props)

        const {controller, fields, token, user} = props

        this.state = {
            controller: controller,
            fields,
            user,
            fieldNumber: (controller && controller.field ? controller.field.field_number : 0),
            chemicalUnits: controller.flowUnitsInt,
            scheduledStart: controller.scheduledStartMode !== "Disabled",
            scheduledStop: controller.scheduledStopMode !== "Disabled",
            repeatStart: controller.scheduledStartMode === "Repeat",
            repeatStop: controller.scheduledStopMode === "Repeat",
            toggleRunning: false,
            batchEnable: controller.batchEnable,
            batchSetpoint: controller.batchSetpoint,
            resetBatchTotal: false,
            scheduledStartTime: controller.scheduledStartTime,
            scheduledStopTime: controller.scheduledStopTime,
            name: controller.name,
            currentChemical: controller.currentChemical,
            resetControllerTotal: false,
            resetWaterTotal: false,
            tankSize: controller.tankSize,
            tankLevel: controller.tankLevel,
            waterReportingUnits: controller.waterReportingUnits,
            maxGaugeChemRate: controller.maxGaugeChemRate,
            chemicalRate: controller.chemicalRateNonAdjustableSetpoint,
            commandStatusModalVisible: false,
            commandStatus: null,
            commandStatusMessage: null,
            commandEEPROMLoginStatus: false,
            commandEEPROMLoginButtonText: "Load EEPROM Login",
            commandID: null,
            token,
            activeTab: "1",
            settingsHistoryLoading: false,
            commands:[],
        }

        this.toggleTab = this.toggleTab.bind(this)

        this.toggleCommandStatusModal = this.toggleCommandStatusModal.bind(this)
        this.sendCommandForRunSettings = this.sendCommandForRunSettings.bind(this)
        this.sendCommandForBatching = this.sendCommandForBatching.bind(this)
        this.sendCommandForScheduling = this.sendCommandForScheduling.bind(this)
        this.sendCommandForField = this.sendCommandForField.bind(this)
        this.sendCommandForControllerInfo = this.sendCommandForControllerInfo.bind(this)
        this.sendCommandForTankInfo = this.sendCommandForTankInfo.bind(this)
        this.handleEEPROMLoginButtonClick = this.handleEEPROMLoginButtonClick.bind(this)
        this.resetForms = this.resetForms.bind(this)
        this.fetchSettingsHistory = this.fetchSettingsHistory.bind(this)

        this.setupCommandTimeoutTimer = this.setupCommandTimeoutTimer.bind(this)
        this.showTimeoutError = this.showTimeoutError.bind(this)
        this.handleCommandWebsocketResponse = this.handleCommandWebsocketResponse.bind(this)
        this.handleControllerWebsocketResponse = this.handleControllerWebsocketResponse.bind(this)
    }

    async componentWillReceiveProps(nextProps) {
        const {controller, fields, token, user} = nextProps

        this.setState({
            controller: controller,
            fields,
            user,
            fieldNumber: (controller && controller.field ? controller.field.field_number : 0),
            chemicalUnits: controller.flowUnitsInt,
            scheduledStart: controller.scheduledStartMode !== "Disabled",
            scheduledStop: controller.scheduledStopMode !== "Disabled",
            repeatStart: controller.scheduledStartMode === "Repeat",
            repeatStop: controller.scheduledStopMode === "Repeat",
            batchEnable: controller.batchEnable,
            batchSetpoint: controller.batchSetpoint,
            scheduledStartTime: controller.scheduledStartTime,
            scheduledStopTime: controller.scheduledStopTime,
            name: controller.name,
            currentChemical: controller.currentChemical,
            tankSize: controller.tankSize,
            waterReportingUnits: controller.waterReportingUnits,
            maxGaugeChemRate: controller.maxGaugeChemRate,
            chemicalRate: controller.chemicalRateNonAdjustableSetpoint,
            token,
            commands:this.state.commands || [],
        })

        if (token && controller) {
            this.setState({settingsHistoryLoading: true})
            await this.fetchSettingsHistory()
            this.setState({settingsHistoryLoading: false})
        }
    }

    async componentDidMount() {
        if (this.state.token && this.state.controller) {
            this.setState({settingsHistoryLoading: true})
            await this.fetchSettingsHistory()
            this.setState({settingsHistoryLoading: false})
        }
    }

    toggleTab = (tab) => () => {
        if (this.state.activeTab !== tab && !this.state.commandStatusModalVisible) {
            this.setState({
                activeTab: tab
            })
        }
    }

    toggleCommandStatusModal() {
        this.setState({commandStatusModalVisible: !this.state.commandStatusModalVisible})
    }

    async fetchSettingsHistory() {
        let {token, controller} = this.state
        if (controller && controller.id) {
            try {
                let {results} = await getCommandHistoryForController(token, controller.id)
                results = results.filter(r => r.change.length)
                this.setState({commands: results})
            } catch (err) {
                console.log(err)
                this.setState({commands: []})
            }
        }
    }

    async sendCommandForRunSettings() {
        let {token, controller, chemicalUnits, chemicalRate} = this.state
        // set command status state props
        // show command status modal
        await this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_API,
            commandStatusModalVisible: true,
            commandStatusMessage: null})
        // get changed props
        // create command obj
        let command = new Command()
        command.controller = controller.id
        command.rate = chemicalRate
        command.units = chemicalUnits
        if (this.state.toggleRunning) {
            command.remoteStartStopSetting = (controller.running ? 1 : 2)
        } else {
            command.remoteStartStopSetting = 0
        }

        // set chem name
        controller.currentChemical = this.state.currentChemical
        controller = await updateController(token, controller)
        this.setState({controller})

        // send to api
        try {
            command = await sendCommand(token, command)
            this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_CON, commandStatusMessage: null, commandID: command.id})
        } catch (error) {
            console.log(error)
            let message = null
            if (error.message && error.message.error) {
                message = String(error.message.error)
            } else if (error.message) {
                message = String(error.message)
            }
            this.setState({commandStatus: COMMAND_STATUSES.FAILED_TO_SEND_TO_API, commandStatusMessage: message, commandID: null})
        }

        // set timeout
        this.setupCommandTimeoutTimer()
    }

    async sendCommandForBatching() {
        let {token, controller, batchEnable, batchSetpoint, resetBatchTotal } = this.state
        // set command status state props
        // show command status modal
        await this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_API,
            commandStatusModalVisible: true,
            commandStatusMessage: null})
        // get changed props
        // create command obj
        let command = new Command()
        command.controller = controller.id
        command.batchEnable = batchEnable
        command.batchSetpoint = batchSetpoint
        command.batchTotalReset = resetBatchTotal

        // send to api
        try {
            command = await sendCommand(token, command)
            this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_CON, commandStatusMessage: null, commandID: command.id})
        } catch (error) {
            console.log(error)
            let message = null
            if (error.message && error.message.error) {
                message = String(error.message.error)
            } else if (error.message) {
                message = String(error.message)
            }
            this.setState({commandStatus: COMMAND_STATUSES.FAILED_TO_SEND_TO_API, commandStatusMessage: message, commandID: null})
        }

        // set timeout
        this.setupCommandTimeoutTimer()
    }

    async sendCommandForScheduling() {
        let {token, controller, scheduledStart, scheduledStartTime, repeatStart,
            scheduledStop, scheduledStopTime, repeatStop } = this.state
        // set command status state props
        // show command status modal
        await this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_API,
            commandStatusModalVisible: true,
            commandStatusMessage: null})
        // get changed props
        // create command obj
        let command = new Command()
        command.controller = controller.id
        command.scheduledStartTime = scheduledStartTime
        command.scheduledStartMode = (scheduledStart ? (repeatStart ? 2 : 1) : 0)
        command.scheduledStopTime = scheduledStopTime
        command.scheduledStopMode = (scheduledStop ? (repeatStop ? 2 : 1) : 0)

        // send to api
        try {
            command = await sendCommand(token, command)
            this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_CON, commandStatusMessage: null, commandID: command.id})
        } catch (error) {
            console.log(error)
            let message = null
            if (error.message && error.message.error) {
                message = String(error.message.error)
            } else if (error.message) {
                message = String(error.message)
            }
            this.setState({commandStatus: COMMAND_STATUSES.FAILED_TO_SEND_TO_API, commandStatusMessage: message, commandID: null})
        }

        // set timeout
        this.setupCommandTimeoutTimer()
    }

    async sendCommandForField() {
        let {token, controller, fieldNumber } = this.state
        // set command status state props
        // show command status modal
        await this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_API,
            commandStatusModalVisible: true,
            commandStatusMessage: null})
        // get changed props
        // create command obj
        let command = new Command()
        command.controller = controller.id
        command.fieldNumber = fieldNumber

        // send to api
        try {
            command = await sendCommand(token, command)
            this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_CON, commandStatusMessage: null, commandID: command.id})
        } catch (error) {
            let message = null
            if (error.message && error.message.error) {
                message = String(error.message.error)
            } else if (error.message) {
                message = String(error.message)
            }
            this.setState({commandStatus: COMMAND_STATUSES.FAILED_TO_SEND_TO_API, commandStatusMessage: message, commandID: null})
        }

        // set timeout
        this.setupCommandTimeoutTimer()
    }

    async sendCommandForTankInfo() {
        let {token, controller, tankSize, tankLevel} = this.state
        // set command status state props
        // show command status modal
        await this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_API,
            commandStatusModalVisible: true,
            commandStatusMessage: null})

        // set tanksize
        controller.tankSize = tankSize
        controller = await updateController(token, controller)
        this.setState({controller})

        // get changed props
        // create command obj
        let command = new Command()
        command.controller = controller.id
        command.tankLevel = tankLevel

         // send to api
        try {
            command = await sendCommand(token, command)
            this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_CON, commandStatusMessage: null, commandID: command.id})
        } catch (error) {
            console.log(error)
            let message = null
            if (error.message && error.message.error) {
                message = String(error.message.error)
            } else if (error.message) {
                message = String(error.message)
            }
            this.setState({commandStatus: COMMAND_STATUSES.FAILED_TO_SEND_TO_API, commandStatusMessage: message, commandID: null})
        }

        // set timeout
        this.setupCommandTimeoutTimer()
    }

    async sendCommandForControllerInfo() {
        let {token, controller, name, resetControllerTotal, resetWaterTotal, maxGaugeChemRate, waterReportingUnits} = this.state
        // set command status state props
        // show command status modal
        await this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_API,
            commandStatusModalVisible: true,
            commandStatusMessage: null})

        // set name and maxgaugechem and water reporting units
        controller.name = name
        controller.maxGaugeChemRate = maxGaugeChemRate
        controller.waterReportingUnits = waterReportingUnits
        controller = await updateController(token, controller)
        this.setState({controller})

        // get changed props
        // create command obj
        let command = new Command()
        command.controller = controller.id
        command.userTotalReset = resetControllerTotal
        command.waterTotalReset = resetWaterTotal

        let shouldSendCommand = (resetWaterTotal || resetControllerTotal)
        if (!shouldSendCommand) {
            this.setState({commandStatus: COMMAND_STATUSES.SUCCESS, commandStatusMessage: null, commandID: command.id})
            this.resetForms()
            return
        }

        // send to api
        try {
            command = await sendCommand(token, command)
            this.setState({commandStatus: COMMAND_STATUSES.SENDING_TO_CON, commandStatusMessage: null, commandID: command.id})
        } catch (error) {
            console.log(error)
            let message = null
            if (error.message && error.message.error) {
                message = String(error.message.error)
            } else if (error.message) {
                message = String(error.message)
            }
            this.setState({commandStatus: COMMAND_STATUSES.FAILED_TO_SEND_TO_API, commandStatusMessage: message, commandID: null})
        }

        // set timeout
        this.setupCommandTimeoutTimer()
    }

    async handleEEPROMLoginButtonClick() {
        let {controller, token, commandEEPROMLoginButtonText} = this.state
        // set command status state props
        // show command status modal
	    controller = await updateController(token, controller)
	    this.setState((controller))
        this.setState({commandEEPROMLoginButtonText: "Sending Request..."})

        try {
            let command = new Command()
            command.controller = controller.id
            command.requestEEPROMLogin=true
            let response = await sendCommand(token, command)
            this.setState({commandEEPROMLoginButtonText: "Request Sent!"})
        } catch (error) {
            let appError = new AppError("Failed to send request", error.message)
            this.setState({errors: [appError]})
        }
        setTimeout(() => {
            this.setState({commandEEPROMLoginButtonText: "Load EEPROM Login"})
        }, 3000)
    }

    resetForms() {
        this.setState({resetControllerTotal: false, resetWaterTotal: false, resetBatchTotal: false, toggleRunning: false})
    }

    setupCommandTimeoutTimer() {
        let timeout = 5 * 60 * 1000
        let commandWaitingID = this.state.commandID
        setTimeout((()=>this.showTimeoutError(commandWaitingID)), timeout)
    }

    showTimeoutError(commandWaitingID) {
        let {commandStatus, commandID} = this.state
        if ((commandStatus === COMMAND_STATUSES.SENDING_TO_CON ||
            commandStatus === COMMAND_STATUSES.WAITING_FOR_RESPONSE) &&
            commandWaitingID === commandID) {
            console.log("Connection timed out")
            this.setState({commandStatus: COMMAND_STATUSES.FAILED_TO_SEND_TO_CON,
                commandStatusMessage: "Connection timed out.",
                commandID: null})
        }
    }

    handleCommandWebsocketResponse(data) {
        let command = Command.fromAPIObject(JSON.parse(data))
        let {commandStatus} = this.state
        if (command.status && command.status === API_COMMAND_STATES.FAILED && command.retries > 2) {
            console.log("Failed to send command to con")
            let message = null
            if (command.response && command.response.error) {
                message = command.response.error
            } else if (command.response) {
                message = String(command.response)
            }
            this.setState({commandStatus: COMMAND_STATUSES.FAILED_TO_SEND_TO_CON,
                commandStatusMessage: message,
                commandID: null})
        } else if (command.status &&
            command.status === API_COMMAND_STATES.SENT &&
            commandStatus === COMMAND_STATUSES.SENDING_TO_CON) {
            this.setState({commandStatus: COMMAND_STATUSES.WAITING_FOR_RESPONSE,
                commandStatusMessage: null,
                commandID: null})
        }
    }

    async handleControllerWebsocketResponse(data) {
        let {controller, commandStatus} = this.state
        let newController = await Controller.fromAPIObject(JSON.parse(data))

        let newStatusFromController = ((controller.latestStatus && newController.latestStatus &&
            controller.latestStatus.id !== newController.latestStatus.id) ||
            (!controller.latestStatus && newController.latestStatus))
        let newExtFromController = ((controller.latestExtendedDataPoint && newController.latestExtendedDataPoint &&
            controller.latestExtendedDataPoint.id !== newController.latestExtendedDataPoint.id) ||
            (!controller.latestExtendedDataPoint && newController.latestExtendedDataPoint))
        let newDataFromController = (newStatusFromController || newExtFromController)
        // if new data from con and status is waiting for response or sending to con
        if (newDataFromController &&
            (commandStatus === COMMAND_STATUSES.WAITING_FOR_RESPONSE || commandStatus === COMMAND_STATUSES.SENDING_TO_CON)) {
            // set status to success
            this.setState({commandStatus: COMMAND_STATUSES.SUCCESS,
                commandStatusMessage: null,
                commandID: null})
            this.resetForms()
        }
        // set form state
        this.setState({ controller: newController })
    }

    render() {
        let { activeTab, controller, chemicalUnits, scheduledStart,
            scheduledStop, repeatStart, repeatStop, fields, fieldNumber,
            currentChemical, toggleRunning, batchEnable, batchSetpoint, resetBatchTotal,
            scheduledStartTime, scheduledStopTime, name, resetControllerTotal,
            resetWaterTotal, tankSize, tankLevel, chemicalRate, commandStatusModalVisible,
            commandStatus, commandStatusMessage, commandEEPROMLoginButtonText, commandID, token, commands,
            settingsHistoryLoading, user, maxGaugeChemRate, waterReportingUnits } = this.state
        let fixedCharacterWidthFields = {date: 6, user: 10.5}
        fixedCharacterWidthFields[STATUS_FIELD_NAME] = 2.7

        let fieldContentGenerators = {date: dateGenerator, user: userGenerator}
        fieldContentGenerators[STATUS_FIELD_NAME] = statusGenerator
        return <div className="command-panel rounded p-0 mt-0 ml-auto mr-auto row col-12 text-center">
            <Nav className="col-3 col-md-2 bg-white rounded p-0" vertical pills>
                <NavItem className="mt-2 mb-2">
                    <NavLink className={(activeTab === "1" ? "active" : null)+" pt-3 pb-3"} onClick={this.toggleTab("1")}>
                        <PlayIcon/><br/>
                        Run Settings
                    </NavLink>
                </NavItem>
                {(controller.legacyAccess ? null :
                        <span>
                        <NavItem>
                            <NavLink className={(activeTab === "2" ? "active" : null)+" pt-3 pb-3"} onClick={this.toggleTab("2")}>
                                <BatchIcon/><br/>
                                Batching
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={(activeTab === "3" ? "active" : null)+" pt-3 pb-3"} onClick={this.toggleTab("3")}>
                                <ClockIcon/><br/>
                                <span className="d-inline-block d-md-none">
                                    Schedule
                                </span>
                                <span className="d-none d-md-inline-block">
                                    Scheduling
                                </span>
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={(activeTab === "4" ? "active" : null)+" pt-3 pb-3"} onClick={this.toggleTab("4")}>
                                <FieldIcon/><br/>
                                Field
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink className={(activeTab === "5" ? "active" : null)+" pt-3 pb-3"} onClick={this.toggleTab("5")}>
                                <DatabaseIcon/><br/>
                                Tank Info
                            </NavLink>
                        </NavItem>
                    </span>
                )}
                <NavItem>
                    <NavLink className={(activeTab === "6" ? "active" : null)+" pt-3 pb-3"} onClick={this.toggleTab("6")}>
                        <SquareIcon/><br/>
                        Controller Info
                    </NavLink>
                </NavItem>
                <NavItem>
                    <NavLink className={(activeTab === "7" ? "active" : null)+" pt-3 pb-3"} onClick={this.toggleTab("7")}>
                        <HistoryIcon/><br/>
                        Settings History
                    </NavLink>
                </NavItem>
            </Nav>
            <TabContent activeTab={activeTab} className="col-9 col-md-10 m-md-0 p-md-0">
                <TabPane tabId="1">
                    <h3 className="text-muted m-3"><PlayIcon/>&nbsp;Run Settings</h3>
                    <Form className="col-12 col-md-6 offset-0 offset-md-3 text-left rounded">
                        <FormGroup className="m-3">
                            <Label for="chemicalRate">
                                Chemical Rate Setpoint
                                <InputGroup>
                                    <Input name="chemicalRate"
                                           type="number"
                                           value={chemicalRate && chemicalRate > 0 ? chemicalRate : ''}
                                           onChange={(e)=>this.setState({chemicalRate:(e.target.value || 0 )})}/>
                                    <InputGroupAddon addonType="append">{FLOW_UNITS[chemicalUnits]}</InputGroupAddon>
                                </InputGroup>
                            </Label>
                        </FormGroup>
                        <FormGroup className="m-3">
                            <Label for="units">
                                Units
                                <Input name="units"
                                       type="select"
                                       disabled={controller.running}
                                       value={chemicalUnits || ''}
                                       onChange={(e)=>this.setState({chemicalUnits:(e.target.value && e.target.value.length ? e.target.value : null)})}>
                                    <option value="0">ml/m</option>
                                    <option value="1">oz/ac</option>
                                    <option value="4">oz/min</option>
                                    <option value="2">Gal/ac</option>
                                    <option value="3">Gal/min</option>
                                    <option value="5">Gal/hr</option>
                                </Input>
                            </Label>
                            <br/>
                            {(controller.running ?
                                <small className="text-muted">
                                    Cannot change units while controller is running.
                                </small>
                                : null)}
                        </FormGroup>
                        <FormGroup className="m-3">
                            <Label for="chemicalName">
                                Current Chemical Name
                                <Input name="chemicalName"
                                       type="text"
                                       value={(currentChemical || "")}
                                       onChange={(e)=>this.setState({currentChemical:e.target.value})}/>
                            </Label>
                        </FormGroup>
                        <FormGroup className="m-3">
                            <Input name="toggleRunning"
                                   type="checkbox"
                                   checked={toggleRunning}
                                   onChange={(e)=>this.setState({toggleRunning:e.target.checked})}
                                   className="ml-1"/>
                            <Label for="toggleRunning"
                                   className="ml-4"
                                   check>
                                {(controller.running ?
                                    <span>
                                        Stop Running&nbsp;<PauseIcon/>
                                    </span> :
                                    <span>
                                            Start Running&nbsp;<PlayIcon/>
                                        </span>)}
                            </Label>
                        </FormGroup>
                        {(commandID ?
                            <Websocket url={`${WS_URL}/commands/${commandID}/?access_token=${token.accessToken}`}
                                       onMessage={this.handleCommandWebsocketResponse}
                                       reconnect={true}/>:
                            null)}
                    </Form>
                    <Button className="m-3" onClick={this.sendCommandForRunSettings}>
                        <SendIcon/>&nbsp;Save Run Settings
                    </Button>
                </TabPane>
                <TabPane tabId="2">
                    <h3 className="text-muted m-3"><BatchIcon/>&nbsp;Batching</h3>
                    <Form className="col-12 col-md-6 offset-0 offset-md-3 text-left rounded">
                        <FormGroup className="m-3">
                            <Input name="batchEnable"
                                   type="checkbox"
                                   checked={batchEnable}
                                   onChange={(e)=>this.setState({batchEnable:e.target.checked})}
                                   className="ml-1"/>
                            <Label for="batchEnable"
                                   className="ml-4"
                                   check>
                                Batch Mode Enabled&ensp;<BatchIcon/>
                            </Label>
                        </FormGroup>
                        {(scheduledStop && batchEnable ?
                            <Badge color="warning" className="text-dark m-2 position-relative" style={{left: "-0.5rem"}}>
                                <WarningIcon className="control-icon"/>
                                <span className="d-inline-block d-sm-none">
                                    &ensp;Batch & Sched. Stop Enabled
                                </span>
                                <span className="d-none d-sm-inline-block">
                                    &ensp;Batching & Scheduled Stop Enabled
                                </span>
                            </Badge>
                            : null)}
                        {(scheduledStop && batchEnable ?
                            <div><small className="text-muted">Controller will stop at whatever comes first.</small></div>
                            : null)}
                        <FormGroup className="m-3">
                            <Label for="batchSetpoint">
                                Batch Setpoint
                                <InputGroup>
                                    <Input name="batchSetpoint"
                                           type="number"
                                           value={batchSetpoint && batchSetpoint > 0 ? batchSetpoint : ''}
                                           onChange={(e)=>this.setState({batchSetpoint:(e.target.value || 0 )})}/>
                                    <InputGroupAddon addonType="append">{controller.batchUnits || "GAL"}</InputGroupAddon>
                                </InputGroup>
                            </Label>
                        </FormGroup>
                        <FormGroup className="m-3">
                            <Input name="resetBatchTotal"
                                   type="checkbox"
                                   checked={resetBatchTotal}
                                   onChange={(e)=>this.setState({resetBatchTotal:e.target.checked})}
                                   className="ml-1"/>
                            <Label for="resetBatchTotal"
                                   className="ml-4"
                                   check>
                                Reset Batch Total&ensp;<ResetIcon/>
                            </Label>
                        </FormGroup>
                    </Form>
                    <Button className="m-3" onClick={this.sendCommandForBatching}>
                        <SendIcon/>&nbsp;Save Batching Settings
                    </Button>
                </TabPane>
                <TabPane tabId="3">
                    <h3 className="text-muted m-3"><ClockIcon/>&nbsp;Scheduling</h3>
                    <Form className="col-12 col-md-6 offset-0 offset-md-3 text-left rounded">
                        <FormGroup className="m-3">
                            <Input name="scheduledStart"
                                   type="checkbox"
                                   className="ml-1"
                                   checked={scheduledStart}
                                   onChange={(e)=>this.setState({scheduledStart: e.target.checked})}/>
                            <Label for="scheduledStart"
                                   className="ml-4"
                                   check>
                                Scheduled Start&ensp;<PlayIcon/>
                            </Label>
                        </FormGroup>
                        <FormGroup className="m-3">
                            <Label for="scheduledStartTime">
                                <ClockIcon/>&nbsp;Start Time
                                <small className="text-muted ml-2">24hr Time <em>(e.g. 15:30)</em></small>
                                <TimeField name="scheduledStartTime"
                                           className='time-input d-block rounded m-1 ml-3'
                                           disabled={!scheduledStart}
                                           value={scheduledStartTime}
                                           onChange={(e)=>this.setState({scheduledStartTime:e})}/>
                            </Label>
                        </FormGroup>
                        <FormGroup className="m-3 mb-4">
                            <Input name="repeatStart"
                                   type="checkbox"
                                   className="ml-1"
                                   disabled={!scheduledStart}
                                   checked={repeatStart}
                                   onChange={(e)=>this.setState({repeatStart: e.target.checked})}/>
                            <Label for="repeatStart"
                                   className="ml-4"
                                   check>
                                Repeat Every Day&ensp;<RepeatIcon/>
                            </Label>
                        </FormGroup>
                        <hr/>
                        <FormGroup className="m-3 mt-4">
                            <Input name="scheduledStop"
                                   type="checkbox"
                                   className="ml-1"
                                   checked={scheduledStop}
                                   onChange={(e)=>this.setState({scheduledStop: e.target.checked})}/>
                            <Label for="scheduledStop"
                                   className="ml-4"
                                   check>
                                Scheduled Stop&ensp;<PauseIcon/>
                            </Label>
                            {(scheduledStop && batchEnable ?
                                <Badge color="warning" className="text-dark m-2 position-relative" style={{left: "-1rem"}}>
                                    <WarningIcon className="control-icon"/>
                                    <span className="d-inline-block d-sm-none">
                                        &ensp;Batch & Sched. Stop Enabled
                                    </span>
                                    <span className="d-none d-sm-inline-block">
                                        &ensp;Batching & Scheduled Stop Enabled
                                    </span>
                                </Badge>
                                : null)}
                            {(scheduledStop && batchEnable ?
                                <div><small className="text-muted">Controller will stop at whatever comes first.</small></div>
                                : null)}
                        </FormGroup>
                        <FormGroup className="m-3">
                            <Label for="scheduledStartTime">
                                <ClockIcon/>&nbsp;Stop Time
                                <small className="text-muted ml-2">24hr Time <em>(e.g. 15:30)</em></small>
                                <TimeField name="scheduledStopTime"
                                           className='time-input d-block rounded m-1 ml-3'
                                           disabled={!scheduledStop}
                                           value={scheduledStopTime}
                                           onChange={(e)=>this.setState({scheduledStopTime:e})}/>
                            </Label>
                        </FormGroup>
                        <FormGroup className="m-3">
                            <Input name="repeatStop"
                                   type="checkbox"
                                   className="ml-1"
                                   disabled={!scheduledStop}
                                   checked={repeatStop}
                                   onChange={(e)=>this.setState({repeatStop: e.target.checked})}/>
                            <Label for="repeatStop"
                                   className="ml-4"
                                   check>
                                Repeat Every Day&ensp;<RepeatIcon/>
                            </Label>
                        </FormGroup>
                    </Form>
                    <Button className="mr-0 ml-0 mt-3 mb-3" onClick={this.sendCommandForScheduling}>
                        <SendIcon/>&nbsp;Save Scheduling Settings
                    </Button>
                </TabPane>
                <TabPane tabId="4">
                    <h3 className="text-muted m-3"><FieldIcon/>&nbsp;Field</h3>
                    <Form className="col-12 col-md-6 offset-0 offset-md-3 text-left rounded">
                        <FormGroup className="m-3">
                            <Label for="field" className="col-12">
                                <ListGroup>
                                    <ListGroupItemHeading>
                                        Field, (Field Integer)
                                    </ListGroupItemHeading>

                                    {fields && fields.length ?
                                        (fields.map((f, idx) =>
                                            <ListGroupItem key={`${idx}-${f.field_number}`}>
                                                <Input name="fieldNumber"
                                                       type="radio"
                                                       className="ml-1"
                                                       checked={fieldNumber === f.field_number}
                                                       onChange={(e)=>this.setState({fieldNumber: f.field_number})}/>
                                                <Label for="fieldNumber"
                                                       className="ml-4"
                                                       check>
                                                    {f.name}
                                                    &ensp;
                                                    <small className="font-weight-bold text-muted align-text-top">
                                                        (#{f.field_number})
                                                    </small>

                                                </Label>
                                            </ListGroupItem>)):
                                                <ListGroupItem>
                                                    <Label for="fieldNumber"
                                                           className="ml-4"
                                                           check>
                                                        No fields available.
                                                    </Label>
                                                </ListGroupItem>
                                    }
                                </ListGroup>
                            </Label>
                        </FormGroup>
                    </Form>
                    <Button className="m-3" onClick={this.sendCommandForField}>
                        <SendIcon/>&nbsp;Save Field Settings
                    </Button>
                </TabPane>
                <TabPane tabId="5">
                    <h3 className="text-muted m-3"><DatabaseIcon/>&nbsp;Tank Info</h3>
                    <Form className="col-12 col-md-6 offset-0 offset-md-3 text-left rounded">
                        <FormGroup className="m-3 mb-4 mt-4">
                            <Label for="tankSize">
                                Tank Size
                                <InputGroup>
                                    <Input name="tankSize"
                                           type="number"
                                           value={tankSize && tankSize > 0 ? tankSize : ''}
                                           onChange={(e)=>this.setState({tankSize:(e.target.value || 0 )})}/>
                                    <InputGroupAddon addonType="append">{controller.batchUnits || "GAL"}</InputGroupAddon>
                                </InputGroup>
                            </Label>
                        </FormGroup>
                        <FormGroup className="m-3">
                            <Label for="tankLevel">
                                Tank Level
                                <InputGroup>
                                    <Input name="tankLevel"
                                           type="number"
                                           value={tankLevel && tankLevel > 0 ? tankLevel : ''}
                                           onChange={(e)=>this.setState({tankLevel:(e.target.value || 0 )})}/>
                                    <InputGroupAddon addonType="append">{controller.batchUnits || "GAL"}</InputGroupAddon>
                                </InputGroup>
                            </Label>
                        </FormGroup>
                    </Form>
                    <Button className="m-3" onClick={this.sendCommandForTankInfo}>
                        <SendIcon/>&nbsp;Save Tank Info
                    </Button>
                </TabPane>
                <TabPane tabId="6">
                    <h3 className="text-muted m-3"><SquareIcon/>&nbsp;Controller Info</h3>
                    <Form className="col-12 col-md-6 offset-0 offset-md-3 text-left rounded">
                        <FormGroup className="m-3 mb-4">
                            <Label for="name" className="mb-1">
                                Controller Name
                                <Input name="name"
                                       type="text"
                                       value={name || ''}
                                       onChange={(e)=>this.setState({name:(e.target.value && e.target.value.length ? e.target.value : null)})}/>
                            </Label>
                        </FormGroup>
                        <FormGroup className="m-3 mb-4">
                            <Label for="maxGaugeChemRate" className="mb-1">
                                Max Chemical Gauge Rate
                                <InputGroup>
                                    <Input name="maxGaugeChemRate"
                                           type="number"
                                           value={maxGaugeChemRate && maxGaugeChemRate > 0 ? maxGaugeChemRate : 0}
                                           onChange={(e)=>this.setState({maxGaugeChemRate:(e.target.value || 0 )})}/>
                                    <InputGroupAddon addonType="append">{controller.flowUnits || "GPH"}</InputGroupAddon>
                                </InputGroup>
                            </Label>

                        </FormGroup>
                        <FormGroup className="m-3 mb-4">
                            <Label for="waterReportingUnits" className="mb-1">
                                Water Reporting Units
                                <Input name="waterReportingUnits"
                                       type="select"
                                       value={waterReportingUnits || ''}
                                       onChange={(e)=>this.setState({waterReportingUnits:(e.target.value && e.target.value.length ? e.target.value : null)})}>
                                    <option value="0">L</option>
                                    <option value="1">G</option>
                                    <option value="2">AC-FT</option>
                                </Input>
                            </Label>
                        </FormGroup>
                        {(controller.legacyAccess ? null :
                            <span>
                                <hr/>
                                <FormGroup className="m-3 mt-4">
                                    <Input name="resetControllerTotal"
                                           type="checkbox"
                                           className="ml-1"
                                           checked={resetControllerTotal}
                                           onChange={(e)=>this.setState({resetControllerTotal:e.target.checked})}/>
                                    <Label for="resetControllerTotal"
                                           className="ml-4"
                                           check>
                                        Reset Controller Chemical Total&ensp;<ResetIcon/>
                                    </Label>
                                </FormGroup>
                                <FormGroup className="m-3">
                                    <Input name="resetWaterTotal"
                                           type="checkbox"
                                           className="ml-1"
                                           checked={resetWaterTotal}
                                           onChange={(e)=>this.setState({resetWaterTotal:e.target.checked})}/>
                                    <Label for="resetWaterTotal"
                                           className="ml-4"
                                           check>
                                        Reset Controller Water Total&ensp;<ResetIcon/>
                                    </Label>
                                </FormGroup>
                            </span>
                        )}
                    </Form>
                    <Button className="m-3" onClick={this.sendCommandForControllerInfo}>
                        <SendIcon/>&nbsp;Save Controller Info
                    </Button>
                    {(user.isSupport ?
                         <span>
			 	<hr/>
			 	<Label className="ml-1">
                             		Press To Reload Login Credentionals From Controller EEPROM&ensp;<ResetIcon/>
                         	</Label>
				<br/>
				<Button className="bg-light-sf-orange m-3" onClick={this.handleEEPROMLoginButtonClick}>
                        		<SendIcon/>&nbsp;{commandEEPROMLoginButtonText}
                        	</Button>
			</span>
                        : null
                    )}
                </TabPane>
                <TabPane tabId="7">
                    <h3 className="text-muted mt-3"><HistoryIcon/>&nbsp;Settings History</h3>
                    {commands && commands.length ?
                        <small className="text-muted mb-3">
                            Last {commands.length} commands sent to&nbsp;
                            {controller && controller.userIdentifiableName ? controller.userIdentifiableName : "controller"}
                        </small>:
                            null
                    }
                    {settingsHistoryLoading ?
                        <div className="mt-5 mb-5 col-12 text-center">
                            <Loader type="TailSpin" color="orange" width={60} height={60}/>
                        </div> :
                        (commands ?
                        <ModelListTable models={commands}
                                        fields={[STATUS_FIELD_NAME, "date", "user", "change"]}
                                        hideableFields={["date", "user"]}
                                        leftAlignFields={["date", "user"]}
                                        boldFields={["date"]}
                                        fixedCharacterWidthFields={fixedCharacterWidthFields}
                                        fieldContentGenerators={fieldContentGenerators}
                                        className="p-0 mt-3 no-ellipse"/>: null)}
                </TabPane>
            </TabContent>
            {commandStatusModalVisible ?
                <CommandStatusModal modal={true}
                                    toggle={this.toggleCommandStatusModal}
                                    status={commandStatus}
                                    errorMessage={commandStatusMessage}/>
                : null}
            {(controller && controller.id && token ?
                <Websocket url={`${WS_URL}/controllers/${controller.id}/?access_token=${token.accessToken}`}
                           onMessage={this.handleControllerWebsocketResponse}
                           reconnect={true}/>:
                null)}
        </div>
    }
}

const API_COMMAND_STATES = {
    SENDING: 0,
    SENT: 1,
    FAILED: 2
}

export default ControllerSettingsPanel



// WEBPACK FOOTER //
// ./src/components/ui/ControllerSettingsPanel.js